module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.woff";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.woff
// module id = 1725
// module chunks = 11